<template>
  <div class="home body-bg">
    <div class="searchAndSort">
      <p-vue-input-text
        type="text"
        class="search"
        v-model="search"
        :placeholder="__('search')"
        @input="filterBuildings"
      />
      <p-vue-dropdown
        :options="orderOptions"
        :optionLabel="'label'"
        :placeholder="__('sort')"
        v-model="order"
        class="dropdown"
        scrollHeight="300px"
        @change="sortBuildings"
      >
        <template #value="{ placeholder }">
          <div class="inner p-d-flex p-jc-between">
            <span>{{ placeholder }}</span>
            <span class="icon">
              <i-icon name="arrow" />
            </span>
          </div>
        </template>
      </p-vue-dropdown>
    </div>
    <div style="overflow-y: scroll; height: calc(100vh - 155px);">
      <local-building
        v-for="(building, index) of buildingsFiltered"
        :key="index"
        :building="building"
        :allowReceptionistModule="allowReceptionistModule"
        @openModal="openModal"
        @showLinks="showLinks"
      ></local-building>
    </div>
  </div>

  <i-override-dialog
    v-model:visible="showModel"
    :style="{
      width: '100%',
      maxWidth: 'calc(100vw - 10px)',
    }"
    :modal="true"
    :dismissableMask="true"
    :title="modalTitle"
  >
    <local-SMS
      v-if="modalType == 'sms'"
      :BID="BIDSelected"
      :close="() => (showModel = false)"
    ></local-SMS>
    <local-last-visit
      v-if="modalType == 'last-visit'"
      :close="() => (showModel = false)"
      :BID="BIDSelected"
      @changeLastVisit="changeLastVisit"
    ></local-last-visit>
    <!-- <local-add-electricity-meter
      v-if="modalType == 'ElectricityMeter'"
      :BID="BIDSelected"
      :close="() => (showModel = false)"
    ></local-add-electricity-meter> -->
    <local-add-fees
      v-if="modalType == 'addUnitFeesItem'"
      :BID="BIDSelected"
      :close="() => (showModel = false)"
    ></local-add-fees>
  </i-override-dialog>
</template>

<script>
import { mapState } from "vuex";
import {
  callProc,
  apiParam,
  apiPType,
  getGlobalApi,
} from "@/services/APointAPI";
import { sort_array_by_field } from "@/services/apointUtil";
import { getWorkerData } from "@/services/service";
import LocalBuilding from "./building";
import LocalSMS from "./sms";
// import LocalAddElectricityMeter from "../v-meters/add-electricity-meter";
import LocalAddFees from "./add-fees";
import LocalLastVisit from "./last-visit";
import { errorReceived } from "@/services/apointUtil";
import { __ } from "@/plugins/i18n/";
import { ScrollTo } from "@/services/Scroll";

export default {
  components: {
    LocalBuilding,
    LocalSMS,
    LocalLastVisit,
    // LocalAddElectricityMeter,
    LocalAddFees,
  },
  data() {
    return {
      buildings: [],
      buildingsFiltered: [],
      search: null,
      order: null,
      orderOptions: [
        { label: __("city") + " - " + __("ascending order"), value: "city" },
        {
          label: __("city") + " - " + __("descending order"),
          value: "city desc",
        },
        {
          label: __("street") + " - " + __("ascending order"),
          value: "street",
        },
        {
          label: __("street") + " - " + __("descending order"),
          value: "street desc",
        },
        {
          label: __("compound") + " - " + __("ascending order"),
          value: "compound",
        },
        {
          label: __("compound") + " - " + __("descending order"),
          value: "compound desc",
        },
      ],
      showModel: false,
      modalType: null,
      modalTitle: null,
      BIDSelected: null,
      allowReceptionistModule: false,
    };
  },
  mounted() {
    if (!this.userNum) getWorkerData().then(() => this.getBuildings());
    else this.getBuildings();
    if (this.buildingsOrder)
      this.order = this.orderOptions.find(
        (f) => f.value == this.buildingsOrder.value
      );
    else this.order = this.orderOptions[0];

    this.$store.commit("api/setSessionData", {
      bID: null,
      buildingAddress: null,
    });
    this.search = this.buildingsSearch;
    this.getAllowReceptionistModule();
  },
  methods: {
    getBuildings() {
      this.$store.dispatch("doLoading", true);
      let procParams = [apiParam("UserNum", this.userNum, apiPType.Int)];
      callProc("WorkerApp_ListBuildings", procParams)
        .then((result) => {
          result = JSON.parse(result);
          this.buildings = result.Table;
          this.buildings.map(
            (build) =>
              (build.showLinks = this.curBID != build.BID ? false : true)
          );
          this.filterBuildings();
          this.sortBuildings();
          this.$store.dispatch("doLoading", false);
          if (this.curBID)
            setTimeout(() => {
              ScrollTo(
                document.querySelector(`div[name='${this.curBID}']`),
                undefined,
                false
              );
            }, 1);
        })
        .catch(() => {
          errorReceived("WorkerApp_ListBuildings");
        });
    },
    filterBuildings() {
      if (this.search && this.search != "")
        this.buildingsFiltered = this.buildings.filter(
          (f) =>
            f.Street.includes(this.search) ||
            f.Number.includes(this.search) ||
            f.compound.includes(this.search) ||
            f.city.includes(this.search) ||
            f.Entrance.includes(this.search)
        );
      else this.buildingsFiltered = this.buildings;
    },
    sortBuildings() {
      switch (this.order.value) {
        case "city":
          this.sort("city", false);
          break;
        case "city desc":
          this.sort("city", true);
          break;
        case "street":
          this.sort("Street", false);
          break;
        case "street desc":
          this.sort("Street", true);
          break;
        case "compound":
          this.sort("compound", false);
          break;
        case "compound desc":
          this.sort("compound", true);
          break;
      }
    },
    sort(field, reverse) {
      sort_array_by_field(this.buildingsFiltered, field, reverse, (a) =>
        a.toUpperCase()
      );
    },
    showLinks(building, show) {
      let last = building.showLinks;
      this.buildings.map((building) => (building.showLinks = false));
      if (last != show) building.showLinks = show;
      if (show) this.$store.commit("setBuildingsBID", building.BID);
    },
    openModal(type, title, BID) {
      this.showModel = true;
      this.modalType = type;
      this.modalTitle = title;
      this.BIDSelected = BID;
    },
    changeLastVisit(BID) {
      let build = this.buildings.find((b) => b.BID == BID);
      build.LastVisit = new Date();
      build.AlertMsg = 0;
      this.showModel = false;
    },
    getAllowReceptionistModule() {
      getGlobalApi("allowReceptionistModule")
        .then((result) => {
          this.allowReceptionistModule = result != 0;
        })
        .catch(() => {
          errorReceived("allowReceptionistModule");
        });
    },
  },
  computed: {
    ...mapState({
      userNum: (state) => state.api.workerID,
      buildingsSearch: (state) => state.api.buildingsSearch,
      buildingsOrder: (state) => state.api.buildingsOrder,
      curBID: (state) => state.curBID,
    }),
  },
  watch: {
    search() {
      this.$store.commit("api/setSessionData", {
        buildingsSearch: this.search,
      });
    },
    order() {
      this.$store.commit("api/setSessionData", {
        buildingsOrder: this.order,
      });
    },
    buildingsSearch() {
      if (this.search != this.buildingsSearch) {
        this.search = this.buildingsSearch;
        this.filterBuildings();
      }
    },
  },
};
</script>

<style scoped>
:deep(.svg) {
  color: var(--color-success);
  width: 15px;
  height: 15px;
}

:deep(.p-panel .p-panel-icons) {
  display: block;
}

.searchAndSort {
  display: grid;
  z-index: 1;
  /* position: fixed; */
  overflow: hidden;
  width: 100%;
  grid-template-columns: 70% 30%;
}

.icon:deep(.svg) {
  width: 15px;
  height: 15px;
}

:deep(.p-dropdown-items-wrapper) {
  max-height: 100%;
}
</style>
